import {Component, OnInit, AfterViewInit, Input, Output, EventEmitter, HostListener} from '@angular/core';

import {LogService} from '../../../../services/log.service';


@Component({
	selector: 'scroll-to-top',
	templateUrl: './scroll-to-top.component.html',
	styleUrls: ['./scroll-to-top.component.scss']
})
export class ScrollToTopComponent implements OnInit, AfterViewInit {
	constructor(
		private log: LogService
	) {}


	showScrollToTop = false;

	// @Input() label = '';
	// @Input() link = '';
	// @Output() linkClick = new EventEmitter();


	ngOnInit() {
	}


	ngAfterViewInit() {
		// console.log('this.label');
		// console.log(this.label);
		// console.log('this.link');
		// console.log(this.link);
	}



	@HostListener('window:scroll', ['$event'])
	checkShowScrollToTop(event: any) {
		// console.log('checkShowScrollToTop');
		// console.log(event);
		this.showScrollToTop = (window.pageYOffset > 65);
	}

	scrollToTop() {
		console.log('scrollToTop');
		window.scrollTo(0, 0);
	}

}



// WEBPACK FOOTER //
// /Users/pat/source/itdevices/gitlab/oceanbluffproductions/oceanbluffproductions-ui/src/app/modules/shared/components/scroll-to-top/scroll-to-top.component.ts